import { Box, Tabs, Tab, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import isValidJson from "src/utils/validJson";
import CustomTabPanel from "src/components/CustomTabPanel";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PackageDetails = ({ eventData }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const hasOnlinePackages = eventData?.package_data?.some(
    (data) => data?.publish_status === "online" || data?.publish_status === null
  );
  const hasOfflinePackages = eventData?.package_data?.some((data) =>
    data?.ticket_info?.some(
      (ticket) =>
        ticket?.ticket_param?.prices_object &&
        isValidJson(ticket?.ticket_param?.prices_object) &&
        (JSON.parse(ticket?.ticket_param?.prices_object)?.offline_entry_price ||
          JSON.parse(ticket?.ticket_param?.prices_object)
            ?.offline_redeemable_price ||
          JSON.parse(ticket?.ticket_param?.prices_object)?.offline_item_price)
    )
  );
  useEffect(() => {
    if (!hasOfflinePackages) {
      setValue(1);
    }
  }, [hasOfflinePackages]);

  return (
    <Stack>
      <Box>
        <Box
          sx={{
            borderRadius: "4px",
            borderBottom: 1,
            borderColor: "divider",
            //   maxWidth: { xs: "230px", md: "350px" },
            mb: 2,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Offline"
              sx={{ width: "50%" }}
              {...a11yProps(0)}
              disabled={!hasOfflinePackages}
            />
            <Tab
              label="Online"
              sx={{ width: "50%" }}
              disabled={
                eventData?.event_type?.handle === "private" ||
                !hasOnlinePackages
              }
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <Stack
          spacing={0.5}
          sx={{
            maxHeight: "14.375rem",
            overflow: "scroll",
            "&::-webkit-scrollbar": {
              width: "2px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "main.primary",
            },
            mt: "1rem",
            pr: "0.75rem",
            overflowX: "hidden",
          }}
        >
          <CustomTabPanel value={value} index={0}>
            {eventData?.package_data?.map((data, index) => {
              const redeemableArray =
                data?.ticket_info?.[1]?.ticket_param?.prices_object;
              const redeemableAmt =
                redeemableArray && isValidJson(redeemableArray)
                  ? JSON.parse(redeemableArray)
                  : null;

              const entry_feeArray =
                data?.ticket_info?.[0]?.ticket_param?.prices_object;
              const entry_fee =
                entry_feeArray && isValidJson(entry_feeArray)
                  ? JSON.parse(entry_feeArray)
                  : null;

              const menu_item_array =
                data?.ticket_info?.[2]?.ticket_param?.prices_object;
              const menuItem =
                menu_item_array && isValidJson(menu_item_array)
                  ? JSON.parse(menu_item_array)
                  : null;

              const packageMaxNumb =
                data?.package_capacity > 0
                  ? data?.package_capacity
                  : data?.package_max;

              const packageActiveInActive = () => {
                if (
                  packageMaxNumb &&
                  (packageMaxNumb === data?.package_given ||
                    (data?.valid_till
                      ? dayjs(data.valid_till).isBefore(dayjs())
                      : dayjs(eventData.distribution_end).isBefore(dayjs())))
                ) {
                  return false;
                } else {
                  return true;
                }
              };

              return (
                <Stack spacing={1} key={index}>
                  <Stack spacing={0.5}>
                    {(entry_fee?.offline_entry_price ||
                      redeemableAmt?.offline_redeemable_price ||
                      menuItem?.offline_item_price) && (
                        <>
                          <Stack direction="row" spacing={1}>
                            <Typography variant="h5">{data?.name}</Typography>
                            {packageActiveInActive() ? (
                              <Typography variant="body2" color="#4CAF50">
                                <span
                                  style={{
                                    height: "6px",
                                    width: "6px",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                    backgroundColor: "#4CAF50",
                                    marginRight: "5px",
                                  }}
                                ></span>
                                Active
                              </Typography>
                            ) : (
                              <Typography variant="body2" color="#FF2626">
                                <span
                                  style={{
                                    height: "6px",
                                    width: "6px",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                    backgroundColor: "#FF2626",
                                    marginRight: "5px",
                                  }}
                                ></span>
                                In Active
                              </Typography>
                            )}
                          </Stack>
                          <Stack>
                            <Stack
                              direction={{ md: "row", xs: "column" }}
                              spacing={3}
                              sx={{ borderBottom: "1px solid #E4E5E7", p: 0.5 }}
                            >
                              {redeemableAmt?.offline_redeemable_price && (
                                <Stack spacing={1}>
                                  <Typography variant="body2">
                                    Redeemable Amount
                                  </Typography>

                                  <Typography variant="body1">
                                    {redeemableAmt?.offline_redeemable_price?.join(
                                      ","
                                    ) || "-"}
                                  </Typography>
                                </Stack>
                              )}
                              {entry_fee?.offline_entry_price && (
                                <Stack spacing={1}>
                                  <Typography variant="body2">
                                    Entry Fees
                                  </Typography>
                                  <Typography variant="body1">
                                    {entry_fee?.offline_entry_price?.join(",") ||
                                      "-"}
                                  </Typography>
                                </Stack>
                              )}

                              {data?.ticket_info?.[0]?.ticket_param
                                ?.ticket_type === "redeemable_items" ? (
                                <Stack spacing={1}>
                                  <Typography variant="body2">
                                    Package Amount
                                  </Typography>
                                  <Typography variant="body1">
                                    {menuItem?.offline_item_price?.join(",") ||
                                      "-"}
                                  </Typography>
                                </Stack>
                              ) : null}

                              {data?.ticket_info?.[0]?.ticket_param
                                ?.ticket_type === "redeemable_items" ? (
                                <Stack spacing={1}>
                                  <Typography variant="body2">
                                    Menu Item QTY
                                  </Typography>
                                  <Typography variant="body1">
                                    {isValidJson(
                                      data?.ticket_info?.[2]?.ticket_param
                                        ?.prices_object
                                    )
                                      ? JSON.parse(
                                        data?.ticket_info?.[2]?.ticket_param
                                          ?.prices_object
                                      )?.offline_item_quantity
                                      : null}
                                  </Typography>
                                </Stack>
                              ) : null}
                            </Stack>
                          </Stack>
                        </>
                      )}
                  </Stack>
                </Stack>
              );
            })}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {eventData?.package_data?.map((data, index) => {
              const packageMaxNumb =
                data?.package_capacity > 0
                  ? data?.package_capacity
                  : data?.package_max;

              const packageActiveInActive = () => {
                if (
                  packageMaxNumb &&
                  (packageMaxNumb === data?.package_given ||
                    (data?.valid_till
                      ? dayjs(data.valid_till).isBefore(dayjs())
                      : dayjs(eventData.distribution_end).isBefore(dayjs())))
                ) {
                  return false;
                } else {
                  return true;
                }
              };
              return (
                <Stack spacing={1} key={index}>
                  <Stack spacing={0.5}>
                    {data?.publish_status === "online" ||
                      data?.publish_status === null ? (
                      <>
                        <Stack direction="row" spacing={1}>
                          <Typography variant="h5">{data?.name}</Typography>
                          {packageActiveInActive() ? (
                            <Typography variant="body2" color="#4CAF50">
                              <span
                                style={{
                                  height: "6px",
                                  width: "6px",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                              ></span>
                              Active
                            </Typography>
                          ) : (
                            <Typography variant="body2" color="#FF2626">
                              <span
                                style={{
                                  height: "6px",
                                  width: "6px",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  backgroundColor: "#FF2626",
                                  marginRight: "5px",
                                }}
                              ></span>
                              In Active
                            </Typography>
                          )}
                        </Stack>
                        <Stack
                          direction={{ md: "row", xs: "column" }}
                          spacing={3}
                          sx={{ borderBottom: "1px solid #E4E5E7", p: 0.5 }}
                        >
                          {data?.ticket_info?.[1]?.ticket_param?.ticket_type ===
                            "partial_redeem" ||
                            data?.ticket_info?.[1]?.ticket_param?.ticket_type ===
                            "fully_redeem" ? (
                            <Stack spacing={1}>
                              <Typography variant="body2">
                                Redeemable Amount
                              </Typography>
                              <Typography variant="body1">
                                {data?.ticket_info?.[1]?.ticket_param?.price}
                              </Typography>
                            </Stack>
                          ) : null}
                          {data?.ticket_info?.[1]?.ticket_param?.ticket_type ===
                            "zero_rupee" ||
                            data?.ticket_info?.[1]?.ticket_param?.ticket_type ===
                            "zero_rupee" ? (
                            <Stack spacing={1}>
                              <Typography variant="body2">
                                Zero Rupee
                              </Typography>
                              <Typography variant="body1">
                                {data?.ticket_info?.[1]?.ticket_param?.price}
                              </Typography>
                            </Stack>
                          ) : null}
                          {data?.ticket_info?.[0]?.ticket_param?.ticket_type ===
                            "entry_fee" ||
                            data?.ticket_info?.[0]?.ticket_param?.ticket_type ===
                            "partial_redeem" ? (
                            <Stack spacing={1}>
                              <Typography variant="body2">
                                Entry Fees
                              </Typography>
                              <Typography variant="body1">
                                {data?.ticket_info?.[0]?.ticket_param?.price}
                              </Typography>
                            </Stack>
                          ) : null}
                          {data?.ticket_info?.[2]?.ticket_param?.ticket_type ===
                            "redeemable_items" ? (
                            <Stack spacing={1}>
                              <Typography variant="body2">
                                Package Amount
                              </Typography>
                              <Typography variant="body1">
                                {data?.ticket_info?.[2]?.ticket_param?.price}
                              </Typography>
                            </Stack>
                          ) : null}
                          {data?.ticket_info?.[0]?.ticket_param?.ticket_type ===
                            "redeemable_items" ? (
                            <Stack spacing={1}>
                              <Typography variant="body2">
                                Menu Item QTY
                              </Typography>
                              <Typography variant="body1">
                                {isValidJson(
                                  data?.ticket_info?.[2]?.ticket_param
                                    ?.prices_object
                                )
                                  ? JSON.parse(
                                    data?.ticket_info?.[2]?.ticket_param
                                      ?.value
                                  )
                                  : null}
                              </Typography>
                            </Stack>
                          ) : null}
                        </Stack>
                      </>
                    ) : null}
                  </Stack>
                </Stack>
              );
            })}
          </CustomTabPanel>
        </Stack>
      </Box>
    </Stack>
  );
};

export default PackageDetails;
